import { createStore } from 'zustand';

import { ChatVisibilityType } from '@/models/ChatModel.ts';
import { makeZustandContextStore } from '@/utils/zustandUtils.tsx';

export type ChatMessagingData = {
  isOpen: boolean;
  visibility: ChatVisibilityType;
};

export type ChatMessagingState = ChatMessagingData & {
  toggleChat: () => void;
  setVisibility: (visibility: ChatVisibilityType) => void;
};

const createChatMessagingStore = (initProps: ChatMessagingData) => {
  return createStore<ChatMessagingState>()(set => ({
    ...initProps,
    toggleChat: () => set(state => ({ isOpen: !state.isOpen })),
    setVisibility: (visibility: ChatVisibilityType) => set({ visibility }),
  }));
};

export const [, ChatMessagingProvider, useChatMessagingState] =
  makeZustandContextStore<ChatMessagingData, ChatMessagingState>(
    'ChatMessaging',
    createChatMessagingStore,
  );
